<template>
  <div>
    <v-toolbar flat color="white" class="pt-3">
      <h2 class="dark-grey--text px-2">User Role: {{userroleinfo.name}}</h2>
      <v-spacer></v-spacer>
      <!-- <v-btn v-if="initialSubmodules!==submodules" round color="primary" @click="saveChanges">Save Changes</v-btn> -->
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>
    <div v-if="displayContents('permissions')">
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="allmodules"
        :expand="expand"
        item-key="moduleId"
        :rows-per-page-items="[25, 50, 100, 250]"
        style="cursor: pointer"
        align-center
      >
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left">
              <v-icon v-if="!props.expanded" class="justify-center">chevron_right</v-icon>
              <v-icon v-else>keyboard_arrow_down</v-icon>
              {{props.item.moduleName}}
            </td>
            <td class="text-xs-center">{{props.item.moduleDescription}}</td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-data-table
            :items="props.item.submodules"
            hide-actions
            :headers="submoduleHeaders"
            :rows-per-page-items="[25, 50, 100, 250]"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{props.item.moduleSubmodule.submodule.name}}</td>
              <td class="text-xs-center">{{props.item.moduleSubmodule.submodule.description}}</td>
              <td class="text-xs-center" v-if="props.item.admin">
                <v-icon
                  color="tick"
                  @click="check(props.item,'admin');updatePermissions(props.item)"
                >check_circle_outline</v-icon>
              </td>
              <td class="text-xs-center" v-else>
                <v-icon
                  color="red"
                  @click="check(props.item,'admin');updatePermissions(props.item)"
                >cancel</v-icon>
              </td>
              <td class="text-xs-center" v-if="props.item.create">
                <v-icon
                  color="tick"
                  @click="check(props.item,'create');updatePermissions(props.item)"
                >check_circle_outline</v-icon>
              </td>
              <td class="text-xs-center" v-else>
                <v-icon
                  color="red"
                  @click="check(props.item,'create');updatePermissions(props.item)"
                >cancel</v-icon>
              </td>
              <td class="text-xs-center" v-if="props.item.read">
                <v-icon
                  color="tick"
                  @click="check(props.item,'read');updatePermissions(props.item)"
                >check_circle_outline</v-icon>
              </td>
              <td class="text-xs-center" v-else>
                <v-icon
                  color="red"
                  @click=";check(props.item,'read');updatePermissions(props.item)"
                >cancel</v-icon>
              </td>
              <td class="text-xs-center" v-if="props.item.update">
                <v-icon
                  color="tick"
                  @click="check(props.item,'update');updatePermissions(props.item)"
                >check_circle_outline</v-icon>
              </td>
              <td class="text-xs-center" v-else>
                <v-icon
                  color="red"
                  @click="check(props.item,'update');updatePermissions(props.item)"
                >cancel</v-icon>
              </td>
              <td class="text-xs-center" v-if="props.item.delete">
                <v-icon
                  color="tick"
                  @click="check(props.item,'delete');updatePermissions(props.item)"
                >check_circle_outline</v-icon>
              </td>
              <td class="text-xs-center" v-else>
                <v-icon
                  color="red"
                  @click="check(props.item,'delete');updatePermissions(props.item)"
                >cancel</v-icon>
              </td>
            </template>
          </v-data-table>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>
    <div v-if="displayContents('users')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn round color="primary" @click="attachContactModal=true">Add Contact to Role</v-btn>
      </v-toolbar>
      <v-data-table
        :headers="contactHeaders"
        :items="userrolecontacts"
        item-key="id"
        class="elevation-1"
        :rows-per-page-items="[25, 50, 100, 250]"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon color="red" @click="removeContactFromRole(props.item)">remove_circle</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.contact.name}}</td>
          <td class="text-xs-center">{{props.item.contact.surname}}</td>
          <td class="text-xs-center">{{props.item.contact.idNumber}}</td>
          <td class="text-xs-center">{{props.item.contact.mobileNumber}}</td>
          <td class="text-xs-center">{{props.item.contact.emailAddress}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>

    <v-dialog persistent v-model="attachContactModal" max-width="900px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD CONTACT TO ROLE</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchContacts"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            max-width="50px"
            class="pa-3"
          ></v-text-field>
          <!-- <v-btn flat color="primary" @click="createContactModal=true">Create New Contact</v-btn> -->
        </v-toolbar>
        <v-data-table
          :search="searchContacts"
          :headers="contactHeaders"
          class="elevation-1"
          :rows-per-page-items="[25, 50, 100, 250]"
          :items="orgcontacts"
          item-key="id"
          align-center
        >
          <template v-slot:items="props">
            <td class="justify-center layout px-0">
              <v-icon
              v-if="!userrolecontacts.map(x=>x.contact.id).includes(props.item.contactId)"
                class="mr-2"
                @click="addUserRoleContact(props.item)"
                color="primary"
              >add_circle_outline</v-icon>
              <!-- <v-icon small @click="deleteItem(props.item.id)">delete</v-icon> -->
            </td>
            <td class="text-xs-center">{{props.item.contact.name}}</td>
            <td class="text-xs-center">{{props.item.contact.surname}}</td>
            <td class="text-xs-center">{{props.item.contact.idNumber}}</td>
            <td class="text-xs-center">{{props.item.contact.mobileNumber}}</td>
            <td class="text-xs-center">{{props.item.contact.emailAddress}}</td>
          </template>
          <template
            v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
        </v-data-table>

        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="attachContactModal=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  props: [
    "userroleinfo",
    "allmodules",
    "allsubmodules",
    "userrolecontacts",
    "orgcontacts",
  ],
  data() {
    return {
      expand: true,
      userRoleInfo: null,
      submodules: [],
      allSubmodules: [],
      initialSubmodules: [],
      allModules: [],
      foreignKey: [],
      activeTabName: "",
      searchContacts: "",
      attachContactModal: false,
      tabs: [
        { name: "permissions", displayName: "Permissions" },
        { name: "users", displayName: "Users" },
      ],
      contactHeaders: [
        {
          text: "Actions",
          align: "center",
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Surname",
          align: "center",
          value: "surname",
        },
        {
          text: "ID Number",
          align: "center",
          value: "idNumber",
        },
        {
          text: "Mobile",
          align: "center",
          value: "mobileNumber",
        },
        {
          text: "Email",
          align: "center",
          value: "emailAddress",
        },
      ],
      headers: [
        //         {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Module Name",
          align: "center",
          value: "moduleName",
        },
        {
          text: "Module Description",
          align: "center",
          value: "moduleDescription",
        },
      ],
      submoduleHeaders: [
        {
          text: "",
          align: "center",
          value: "submoduleName",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          value: "submoduleDescription",
          sortable: false,
        },
        {
          text: "Admin Rights",
          align: "center",
          value: "admin",
          sortable: false,
        },
        {
          text: "Create",
          align: "center",
          value: "create",
          sortable: false,
        },
        {
          text: "Read",
          align: "center",
          value: "read",
          sortable: false,
        },
        {
          text: "Update",
          align: "center",
          value: "update",
          sortable: false,
        },
        {
          text: "Delete",
          align: "center",
          value: "delete",
          sortable: false,
        },
      ],
    };
  },

  created() {
    this.initialize();
    this.setActiveTabName("permissions");
  },
  async mounted() {
    this.setActiveTabName("permissions");
  },

  methods: {
    addUserRoleContact(item) {
      if(!this.userroleinfo.isAdmin){
        Api()
        .post("/userRoleContact", {
          organisationId: this.$store.state.currentOrg.org.id,
          userRoleId: this.$route.params.userRoleId,
          contactId: item.contactId,
          isActive: true,
          isDeleted: false,
        })
        .then((response) => {
          this.$emit("userRoleContactChange"),
            (this.attachContactModal = false);
        });
      } else {
        if(item.userType !== 'organisationAdmin'){
          Api().put('/organisationContact/'+item.id,{userType: 'organisationAdmin'}).then(res=>{
            Api()
        .post("/userRoleContact", {
          organisationId: this.$store.state.currentOrg.org.id,
          userRoleId: this.$route.params.userRoleId,
          contactId: item.contactId,
          isActive: true,
          isDeleted: false,
        })
        .then((response) => {
          this.$emit("userRoleContactChange"),
            (this.attachContactModal = false);
        });
          })
        } else {
          Api()
        .post("/userRoleContact", {
          organisationId: this.$store.state.currentOrg.org.id,
          userRoleId: this.$route.params.userRoleId,
          contactId: item.contactId,
          isActive: true,
          isDeleted: false,
        })
        .then((response) => {
          this.$emit("userRoleContactChange"),
            (this.attachContactModal = false);
        });
        }
      }
      
    },
    removeContactFromRole(item) {
      Api()
        .put("/userRoleContact/" + item.id, {
          isActive: false,
          isDeleted: true,
        })
        .then((response) => {
          this.$emit("userRoleContactChange");
        });
    },
    updatePermissions(item) {
      // if(this.userroleinfo.isAdmin){
      //   confirm('You do not have permission to remove Admin Role access.')
      // } else {
      if (item.admin) {
        item.read = true;
        item.create = true;
        item.update = true;
        item.delete = true;
      } else if (item.create || item.update || item.delete) {
        item.read = true;
      }
      Api().put("/routePermission/" + item.id, {
        create: item.create,
        read: item.read,
        update: item.update,
        delete: item.delete,
        admin: item.admin,
      });
      // }
    },
    check(item, type) {
      if (type === "admin") {
        item.admin = !item.admin;
      }
      if (type === "create") {
        item.create = !item.create;
      } else if (type === "read") {
        item.read = !item.read;
      } else if (type === "update") {
        item.update = !item.update;
      } else if (type === "delete") {
        item.delete = !item.delete;
      }
    },

    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },

    initialize() {
      // this.fetchSubmodules();
      // this.fetchModules();
      // this.fetchuserRoleInfo();
    },
    async saveChanges() {
      let submodulePost = [];
      for (let i = 0; i < this.submodules.length; i++) {
        if (this.initialSubmodules.indexOf(this.submodules[i]) === -1) {
          await submodulePost.push({
            moduleId: this.$route.params.moduleId,
            submoduleId: this.submodules[i].id,
            isActive: true,
            isDeleted: false,
          });
        }
      }
      await Api().post("/moduleSubmodule", {
        batch: submodulePost,
      });
      for (let x = 0; x < this.initialSubmodules.length; x++) {
        if (this.submodules.indexOf(this.initialSubmodules[x]) === -1) {
          let subModuleId = this.initialSubmodules[x].id;
          let foreignKeyId = this.foreignKey.filter(function (el) {
            return el.subModuleId === subModuleId;
          });
          await Api().put("/moduleSubmodule/" + foreignKeyId[0].id, {
            isActive: false,
            isDeleted: true,
          });
        }
      }
      this.fetchuserRoleInfo();
    },
  },
};
</script>
<style>
.Planned {
  border-left: solid #d61212;
}
.Ongoing {
  border-left: 4px solid #eb780c;
}
.Complete {
  border-left: 4px solid #5eb110;
}
.Live {
  border-left: 4px solid #5eb110;
}
</style>
